import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { ticksToMs } from '../utils';

dayjs.extend(utc);

/** Same UTC display as FileShareForm access / expiry rows. */
const SHARE_EXPIRATION_UTC_FORMAT = 'YYYY-MM-DD HH:mm [UTC]';

/**
 * Format .NET share-expiration ticks as UTC wall time.
 * Matches FileShareForm: dayjs.utc(ticksToMs(ticks)).format('YYYY-MM-DD HH:mm [UTC]').
 */
export function formatShareExpirationAt(ticks: number): string {
  return dayjs.utc(ticksToMs(ticks)).format(SHARE_EXPIRATION_UTC_FORMAT);
}
